module.exports = __webpack_public_path__ + "img/bank-2.a3f374a2.png";